import { getLabelFallback } from '@utils/utils';
import { ReactElement } from 'react';
import { useFormContext } from 'react-hook-form';

import Error from '@images/svg-icons/error.svg';
import Success from '@images/svg-icons/success.svg';

type InputElementProps = {
    classes?: string;
    id: string;
    value?: string;
    placeholder: string;
    placeholder2?: string;
    required?: boolean;
    pattern?: {value: any, message: string};
    type: string;
    onChange?: Function;
    inputMode?: 'text' | 'numeric';
    validate?: any;
    claim?: string;
    icon?: any;
    onClickIcon?: () => void;
    onKeyPressInput?: (e) => void;
    maxLength: number;
    onKeyUp?: () => void;
}

type InputElement = HTMLInputElement | HTMLTextAreaElement;

const InputElement = (props: InputElementProps) : ReactElement => {
    const { register, formState: {errors}, watch } = useFormContext();
    const {
        classes = '',
        id,
        placeholder,
        placeholder2 = '',
        required,
        pattern,
        type,
        onChange,
        inputMode, 
        validate,
        claim = '',
        icon,
        onClickIcon,
        onKeyPressInput,
        maxLength,
        onKeyUp
    } = props;

    const valid = !errors[id] && watch(id) && watch(id).length > 0;

    return (
        <div className={`input ${classes} ${valid ? 'valid' : ''} ${errors[id] ? 'not-valid' : ''}`}>
            <input className={`input-element ${errors[id] ? 'not-valid' : valid ? 'valid' : ''}`}
                id={id}
                name={id}
                type={type}
                {...register(id, {required: required, pattern: pattern, validate: validate})}
                placeholder={placeholder + placeholder2}
                aria-invalid={errors[id] ? 'true' : 'false'}
                inputMode={inputMode}
                onKeyPress={!!onKeyPressInput ? (e) => {
                    onKeyPressInput(e);
                } : null}
                maxLength={maxLength}
                onKeyUp={!!onKeyUp ? () => onKeyUp() : null}
            />
            <label className="input-label">{placeholder}</label>
            <div className="input-icons">
                <div className="input-icon">{errors[id] ? <Error /> : valid ? <Success /> : ''}</div>
                {!!icon && !!onClickIcon &&<div className="input-icon pointer" onClick={onClickIcon}>{icon}</div>}
            </div>
            {!!claim && claim.length > 0 && <span className="input-claim">{claim}</span>}
            {errors[id] && <span className="input-error">{errors[id].message || getLabelFallback('FIELD_REQUIRED_LABEL').replace('{FIELD_NAME}', placeholder.toLocaleLowerCase())}</span>}
        </div>
    )
}

export default InputElement;